import { render } from "./PaginationSMBox.vue?vue&type=template&id=3d33d280"
import script from "./PaginationSMBox.vue?vue&type=script&lang=js"
export * from "./PaginationSMBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/pagination/PaginationSMBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d33d280"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d33d280', __exports__)) {
    api.reload('3d33d280', __exports__)
  }
  
  module.hot.accept("./PaginationSMBox.vue?vue&type=template&id=3d33d280", () => {
    api.rerender('3d33d280', render)
  })

}


export default __exports__